import { useEffect } from 'react';

/**
 * Hook React pour nettoyer automatiquement les flux média résiduels
 * À utiliser dans la page fin-consultation
 */
export const useMediaCleanup = () => {
  useEffect(() => {
    console.log("=== VÉRIFICATION MÉDIA PAGE FIN-CONSULTATION ===");
    
    // Vérifier si un nettoyage est nécessaire
    const needsCleanup = sessionStorage.getItem('needsMediaCleanup');
    
    if (needsCleanup === 'true') {
      console.log("⚠️ Nettoyage nécessaire détecté");
      sessionStorage.removeItem('needsMediaCleanup');
    }
    
    // Fonction pour nettoyer tous les médias actifs
    const cleanupAllMedia = () => {
      let cleaned = false;
      
      // 1. Nettoyer tous les éléments <video>
      const videoElements = document.querySelectorAll('video');
      if (videoElements.length > 0) {
        console.log(`🔍 ${videoElements.length} élément(s) <video> trouvé(s)`);
        
        videoElements.forEach((video, index) => {
          try {
            if (video.srcObject) {
              const tracks = video.srcObject.getTracks();
              
              if (tracks.length > 0) {
                console.log(`⚠️ Vidéo ${index} a ${tracks.length} track(s) actif(s) - ARRÊT FORCÉ`);
                
                tracks.forEach(track => {
                  track.stop();
                  console.log(`✓ Track ${track.kind} arrêté (vidéo ${index})`);
                  cleaned = true;
                });
                
                video.srcObject = null;
              }
            }
            
            // Supprimer l'élément du DOM
            video.remove();
            console.log(`✓ Élément <video> ${index} supprimé du DOM`);
          } catch (error) {
            console.error(`Erreur nettoyage vidéo ${index}:`, error);
          }
        });
      }
      
      // 2. Nettoyer tous les éléments <audio>
      const audioElements = document.querySelectorAll('audio');
      if (audioElements.length > 0) {
        console.log(`🔍 ${audioElements.length} élément(s) <audio> trouvé(s)`);
        
        audioElements.forEach((audio, index) => {
          try {
            if (audio.srcObject) {
              const tracks = audio.srcObject.getTracks();
              
              if (tracks.length > 0) {
                console.log(`⚠️ Audio ${index} a ${tracks.length} track(s) actif(s) - ARRÊT FORCÉ`);
                
                tracks.forEach(track => {
                  track.stop();
                  console.log(`✓ Track ${track.kind} arrêté (audio ${index})`);
                  cleaned = true;
                });
                
                audio.srcObject = null;
              }
            }
            
            audio.remove();
            console.log(`✓ Élément <audio> ${index} supprimé du DOM`);
          } catch (error) {
            console.error(`Erreur nettoyage audio ${index}:`, error);
          }
        });
      }
      
      // 3. Vérifier les MediaStream actifs via l'API
      if (navigator.mediaDevices && navigator.mediaDevices.enumerateDevices) {
        navigator.mediaDevices.enumerateDevices()
          .then(devices => {
            const videoInputs = devices.filter(d => d.kind === 'videoinput');
            const audioInputs = devices.filter(d => d.kind === 'audioinput');
            console.log(`📹 Devices disponibles: ${videoInputs.length} caméra(s), ${audioInputs.length} micro(s)`);
          })
          .catch(err => console.log("Erreur énumération devices:", err));
      }
      
      if (cleaned) {
        console.log("✅ Nettoyage effectué - Flux média arrêtés");
      } else {
        console.log("✅ Aucun flux média actif détecté");
      }
    };
    
    // Nettoyer immédiatement au montage
    cleanupAllMedia();
    
    // Nettoyer également après 500ms (au cas où des éléments seraient ajoutés tardivement)
    const timeoutId = setTimeout(() => {
      console.log("🔄 Vérification secondaire après 500ms...");
      cleanupAllMedia();
    }, 500);
    
    // Cleanup au démontage
    return () => {
      clearTimeout(timeoutId);
      console.log("Hook useMediaCleanup démonté");
    };
  }, []); // Exécuter une seule fois au montage
};

export default useMediaCleanup;